import { Component, OnInit, AfterViewInit } from '@angular/core';
import { CrudService } from '../crud.service';

// lightgallery
import 'lg-zoom.js';
import 'lg-share.js';
import 'lg-video.js';
import 'lg-pager.js';
import 'lg-autoplay.js';
import 'lg-fullscreen.js';
import 'lg-hash.js';
import 'lg-thumbnail.js';
declare let $: any;
declare var lightGallery: any;

@Component({
  selector: 'app-labs',
  templateUrl: './labs.component.html',
  styleUrls: ['./labs.component.scss']
})
export class LabsComponent implements OnInit, AfterViewInit {

  constructor(private crudService: CrudService) { }

  baseUrl = this.crudService.baseUrl;

  ngOnInit(): void {
  }

  ngAfterViewInit(){
    setTimeout(()=>{
      /*---------------------------
      :: lightBox Gallery
      -----------------------------*/
      let galerias = document.getElementsByClassName('video-gallery');
       for (let i = 0; i < galerias.length; i++) {
         galerias[i].id = 'gal' + i;
         lightGallery(document.getElementById('gal' + i), {
           selector: 'a',
         });
       }

       let galImage = document.getElementsByClassName('lightgallery');

        for (const gal of galImage) {
          lightGallery(gal), {
            selector: 'a',
          }
        }
     }, 3000);
  }

}
